// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountValue } from './account-value';
import { Admin } from './admin';
import { DocumentDatum } from './document-datum';
import { DocumentRecipient } from './document-recipient';
import { Lodgement } from './lodgement';
import { User } from './user';
import { iTask } from './i-task';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Document extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  documentId!: number;
  accountId?: number;
  actualDestructionDate?: Date;
  adminId!: number;
  assetId?: number;
  authorisationTaskId?: number;
  authorisedByUserId?: number;
  bankruptId?: number;
  batchId?: number;
  category?: string;
  checkedOutTo?: string;
  contactId?: number;
  counterpartyId?: number;
  createdBy!: string;
  createdDate!: Date;
  creditorId?: number;
  despatchTaskId?: number;
  dividendId?: number;
  employeeId?: number;
  entryId?: number;
  fileName?: string;
  flags?: number;
  isPublic?: boolean;
  isUnderAdminRoot?: boolean;
  keyWords?: string;
  liabilityId?: number;
  lodgementId?: number;
  meetingId?: number;
  path?: string;
  reconciliationId?: number;
  returnByDate?: Date;
  securityId?: number;
  sentByUserId?: number;
  shareholderId?: number;
  targetDestructionDate?: Date;
  taskId?: number;
  ts!: string;
  uid!: string;
  updatedBy!: string;
  updatedDate!: Date;
  userId?: number;
  webFlags?: number;
  accountValues!: AccountValue[];
  admin!: Admin;
  authorisationTask!: iTask;
  authorisedByUser!: User;
  despatchTask!: iTask;
  documentDatum!: DocumentDatum;
  documentRecipients!: DocumentRecipient[];
  lodgement!: Lodgement;
  sentByUser!: User;
  user!: User;
}

